import {useSelector} from "react-redux";
import {selectEntity} from "state/selectors/data";

export function useData({type, id}) {
    return useSelector(store=>selectEntity(store, type, id));
}